export default "__VITE_ASSET__BmeQgs19__"